// extracted by mini-css-extract-plugin
module.exports = {"container":"BorderedTag_container__3CMzt","type-danger":"BorderedTag_type-danger__3sQ4v"};